import {FormChooseExternal} from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemOoName, FormItemOoNo} from '../OO/FormChooseOo.jsx'
import {FormItemOuName} from '../OU/FormChooseOu.jsx'

export default function FormChooseOu(props) {
    return (
        <FormChooseExternal {...props}>
            <FormItemOoNo />
            <FormItemOoName />
            <FormItemOuName />
        </FormChooseExternal>
    )
}
